module.exports = __webpack_public_path__ + "img/harald_schumann.c7a58c66.png";